// extracted by mini-css-extract-plugin
export default {"app":"App_app__qGBnV","header":"App_header__VwnND","main":"App_main__OBVMg","footer":"App_footer__s96G8"};